// Keep pack sizes, brands and units separate so unlike quantities are never added.
export const getSupplierPurchaseHistory = (orders, supplierId, catalog = []) => {
  if (!supplierId) return [];
  const products = new Map();
  const ordered = [...(orders || [])].sort((a, b) => {
    const date = order => Date.parse(order.arrived_date || order.created_at || '') || 0;
    return date(b) - date(a) || Number(b.id || 0) - Number(a.id || 0);
  });
  for (const order of ordered) {
    if (String(order.supplier_id) !== String(supplierId) ||
        !['received', 'verified'].includes(String(order.status || '').toLowerCase())) continue;
    const items = order.items?.length ? order.items : order.bill_details?.items;
    for (const item of Array.isArray(items) ? items : []) {
      const barcodeId = item.product_barcode_id || item.product_barcode_id_fk || item.barcode_id;
      const pack = catalog.find(row => barcodeId && String(row.id) === String(barcodeId)) ||
        catalog.find(row => ['product_id', 'brand_id', 'category_id', 'unit_id'].every(
          field => item[field] != null && String(row[field]) === String(item[field])
        ) && Number(row.quantity ?? row.qty) === Number(item.qty));
      const quantity = Number(item.qty ?? pack?.quantity ?? 0);
      const units = Number(item.no_of_units ?? 1);
      if (!Number.isFinite(quantity) || !Number.isFinite(units) || quantity < 0 || units < 0) continue;
      const productName = item.product_name || pack?.product_name_eng || pack?.product_name_tel || item.product_code || `Product ${item.product_id}`;
      const brandName = item.brand_name || pack?.brand_name_english || pack?.brand_name_telugu || '';
      const unitName = item.unit_short_code || item.unit_name || pack?.unit_short_code || pack?.unit_name || '';
      const priceValue = [item.actual_unit_price, item.expected_unit_price, item.unit_price, item.price]
        .find(value => value !== null && value !== undefined && value !== '');
      const price = Number(priceValue ?? 0);
      const validPrice = Number.isFinite(price) && price >= 0 ? price : 0;
      const key = JSON.stringify([
        item.product_id ?? pack?.product_id ?? productName,
        item.brand_id ?? pack?.brand_id ?? brandName,
        item.category_id ?? pack?.category_id ?? item.category_name ?? '',
        item.unit_id ?? pack?.unit_id ?? unitName,
        quantity,
      ]);
      if (!products.has(key)) products.set(key, {
        key, productName, brandName, unitName, packQuantity: quantity,
        totalUnits: 0, totalQuantity: 0, totalAmount: 0, lastUnitPrice: validPrice,
        purchaseItem: {
          supplier_id: Number(supplierId),
          product_barcode_id: barcodeId || pack?.id || null,
          product_id: item.product_id ?? pack?.product_id,
          category_id: item.category_id ?? pack?.category_id,
          brand_id: item.brand_id ?? pack?.brand_id,
          unit_id: item.unit_id ?? pack?.unit_id,
          product_name: productName,
          product_code: item.product_code || pack?.product_code || '',
          category_name: item.category_name || pack?.category_name_english || pack?.category_name_telugu || '',
          brand_name: brandName,
          unit_name: unitName,
          mk_barcode: item.mk_barcode || pack?.mk_barcode || '',
          barcode: item.barcode || pack?.barcode || '',
          qty: quantity,
          no_of_units: units > 0 ? units : 1,
          expected_unit_price: validPrice,
          actual_unit_price: null,
        },
      });
      const row = products.get(key);
      row.totalUnits += units;
      row.totalQuantity += quantity * units;
      row.totalAmount += validPrice * units;
    }
  }
  return [...products.values()].sort((a, b) => a.productName.localeCompare(b.productName) || a.packQuantity - b.packQuantity);
};
